<template>
  <div v-if="id !== undefined">
    <div v-if="surveysData" class="survey-info py-3 ps-4">
      <div
        class="col-9 d-flex justify-content-between align-items-center w-100"
      >
        <h5 class="card-title mb-0">
          {{ surveysData.dataset.surveyGroupName }} &nbsp; (
          {{ surveysData.dataset.total }} )
        </h5>
        <h5 class="card-description text-uppercase mb-0">
          {{ surveysData.dataset.year }}
          <span v-if="surveysData.dataset.quarter !== undefined">
            - R{{ surveysData.dataset.quarter.substring(1) }}</span
          >
        </h5>
      </div>
    </div>

    <div class="container py-5">
      <div v-if="surveysData" :class="'customerSegmentation' + id + index">
        <completed-survey-card
          :class-card="'customerSegmentation' + id + index"
          :dataset="surveysData.dataset"
          :index="index"
          type="yes"
        />
      </div>

      <template>
        <div
          v-for="(item, index) in ['experience', 'commitment']"
          :key="index + item"
        >
          <div
            class="container-section p-4 mt-4"
            v-if="pillarScoresData && pillarScoresData[index]"
          >
            <h3 class="container-section-header">
              {{ item }}
            </h3>
            <p
              class="score"
              :style="{
                color: colorByAverageScore(pillarScoresData[index].avgScore),
              }"
            >
              {{ pillarScoresData[index].avgScore.toFixed(2) }}
            </p>

            <simple-gradient-range-chart
              :id="`${id}-${index}`"
              :score="pillarScoresData[index].avgScore"
              :scallMin="index == 0 ? -100 : -50"
            />
          </div>
        </div>

        <div class="container-section p-4 mt-4">
          <h3 class="container-section-header">network</h3>
          <p v-if="pillarScoresData && pillarScoresData[2]" class="score">
            {{ pillarScoresData[2].avgScore.toFixed(2) }} X
          </p>
        </div>
      </template>

      <template v-if="experienceDistributionDataset && surveysData">
        <bar-chart
          v-if="experienceDistributionDataset"
          :dataset="experienceDistributionDataset"
          :index="+id + 6"
          :scallMax="150"
          :scallMin="-100"
          :surveyId="id"
          :title="'Engagement'"
        />
      </template>

      <template v-if="experienceDriversDataSet">
        <div v-for="item in 3" :key="item">
          <div class="container-section p-4 mt-4">
            <h4 class="text-capitalize mb-5">
              {{ drivers[item - 1].title }} Scores
            </h4>
            <div>
              <experience-drivers-yes
                v-if="
                  experienceDriversDataSet[item.toString()] &&
                  experienceDriversDataSet[item.toString()].length
                "
                :className="`${drivers[item - 1].title}-${item}-${id}`"
                :dataset="experienceDriversDataSet[item.toString()]"
                :type="drivers[item - 1].title"
                :scallMin="drivers[item - 1].scallMin"
                :scallMax="drivers[item - 1].scallMax"
              ></experience-drivers-yes>
            </div>
          </div>
          <!--  -->
          <div class="answers-summery">
            <div
              class="container-section p-4 mt-4"
              v-if="questionAnswersPerSectionData"
            >
              <h4 class="text-capitalize mb-5">
                {{ drivers[item - 1].title }} Answer Choices
              </h4>

              <div>
                <div>
                  <div
                    ref="container"
                    class="row justify-content-center align-items-center answers-summery-content"
                  >
                    <a
                      v-for="(mode, index) in questionAnswersPerSectionData[
                        item.toString()
                      ]"
                      :key="'SummeryOfAnswers-' + index"
                      class="summery-of-answer-item"
                      @click="goToAnswersDetails(index, mode.questionId)"
                      :class="gridClass"
                    >
                      <donut-chart
                        :countOfQuestion="
                          questionAnswersPerSectionData[1].length
                        "
                        :dataset="mode"
                        :isYesSurvey="true"
                        :index="index"
                        :surveyId="id"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--  -->
        </div>
      </template>

      <template
        v-if="
          totalSubmissionCount &&
          surveyLanguageBreakdown &&
          surveyLanguageBreakdown.length > 1
        "
      >
        <languages-breakdown
          :languages-data="surveyLanguageBreakdown"
          :totalLanguagesSubmissionsCount="totalSubmissionCount"
        ></languages-breakdown>
      </template>

      <div v-if="commentsCounts" class="mt-4">
        <comments-breakdown
          :commentsCounts="commentsCounts"
          :survey-id="+id"
          surveyType="RED"
        ></comments-breakdown>
      </div>
    </div>
  </div>
</template>
<script>
import LanguagesBreakdown from "@/components/dashboard/surveys-charts/individual/languages-breakdown";
import CommentsBreakdown from "@/components/dashboard/surveys-charts/individual/comments-breakdown.vue";

import { mapGetters } from "vuex";
import ExperienceDriversYes from "../surveys-charts/individual/yes-charts/experience-drivers-yes.vue";
import BarChart from "../surveys-charts/shared/bar-chart.vue";
import CompletedSurveyCard from "../surveys-cards/completed-survey-card.vue";
import SimpleGradientRangeChart from "../surveys-charts/shared/simple-gradient-range-chart.vue";
import { DRIVERS } from "@/constants/index";
import DonutChart from "../surveys-charts/shared/donutChart.vue";

export default {
  name: "SurveyForCompare",

  components: {
    LanguagesBreakdown,
    CommentsBreakdown,
    ExperienceDriversYes,
    BarChart,
    CompletedSurveyCard,
    SimpleGradientRangeChart,
    DonutChart,
  },

  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters("mainStats", {
      surveyWithPersonasByIdCompare: "surveyWithPersonasByIdCompare",
      pillarScoresCompareData: "pillarScoresCompareData",
      surveysCommentsCountsData: "getCommentsCountsCompareData",
      languagesBreakdownCompareData: "getLanguagesBreakdownCompareData",
      allDriversYesCompareData: "allDriversYesCompareData",
      getOverallDistributionCompareData: "getOverallDistributionCompareData",
      questionAnswersPerSectionCompare: "questionAnswersPerSectionCompare",
    }),
    gridClass() {
      return {
        "col-4": this.questionAnswersPerSectionData["1"].length == 5,
        "col-6": this.questionAnswersPerSectionData["1"].length == 4,
      };
    },
    drivers() {
      return DRIVERS;
    },
    surveysData() {
      return this.surveyWithPersonasByIdCompare.find(
        (element) => +element.dataset?.surveyId === +this.id
      );
    },

    questionAnswersPerSectionData() {
      return this.questionAnswersPerSectionCompare.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    pillarScoresData() {
      return this.pillarScoresCompareData.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    experienceDistributionDataset() {
      return this.getOverallDistributionCompareData?.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    experienceDriversDataSet() {
      return this.allDriversYesCompareData.find(
        (element) => +element?.surveyId === +this.id
      )?.dataset;
    },

    commentsCounts() {
      return this.surveysCommentsCountsData.find(
        (element) => +element.surveyId === +this.id
      )?.dataset;
    },

    surveyLanguageBreakdown() {
      return (
        this.languagesBreakdownCompareData.find(
          (element) => +element.surveyId === +this.id
        )?.dataset ?? []
      );
    },

    totalSubmissionCount() {
      let total = 0;
      for (let i in this.languagesBreakdown) {
        total += this.languagesBreakdown[i].langCount;
      }
      return total;
    },
  },

  async mounted() {
    try {
      // setTimeout(() => {});

      await this.$store.dispatch("mainStats/loadSurveyWithPersonasById", {
        surveyId: this.id,
        multiSurvey: true,
        surveyType: "YES",
      });

          await this.$store.dispatch("mainStats/fetchPillarScores", {
        surveyId: this.id,
        multiSurvey: true,
      });

      await this.$store.dispatch("mainStats/fetchOverallDistributionGrouped", {
        surveyId: this.id,
        multiSurvey: true,
      });

      await this.$store.dispatch("mainStats/fetchAllDriversYes", {
        surveyId: this.id,
        multiSurvey: true,
      });

      await this.$store.dispatch("mainStats/fetchQuestionAnswersPerSection", {
        surveyId: this.id,
        isDemographic: false,
        multiSurvey: true,
      });

      await this.$store.dispatch("mainStats/fetchSurveyCommentsCount", {
        surveyId: this.id,
        multiSurvey: true,
      });


      await this.$store.dispatch("mainStats/fetchSurveyLanguageBreakdown", {
        surveyId: this.id,
        multiSurvey: true,
      });

      // setTimeout(() => {}, 600);

      // setTimeout(() => {

      // }, 900);

      // setTimeout(() => {}, 1200);

      // setTimeout(() => {

      // }, 1800);
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.card-title {
  text-align: left;
  font-weight: $font-weight-semiBold;
  color: $color-white;
  opacity: 1;
}

.card-description {
  text-align: left;
  color: $color-white;
  opacity: 1;
}

.survey-info {
  position: sticky;
  top: 0;
  background: $color-grey-100;
  z-index: 5;
  border-bottom: 1px solid $color-grey-60;
  p {
    color: $color-white;
  }

  .product-name {
    font-weight: $font-weight-semiBold;
  }
}

.score {
  font-weight: $font-weight-light;
  font-size: 6rem;
  line-height: 7.9rem;
}
</style>
